// @mui material components
import { Snackbar, Alert, Card, CircularProgress, Backdrop, Icon } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";

import { useAuthUser } from "react-auth-kit";
import AppConfig from "appConfig";

function Customers() {
  const pageTitle = "Customers";
  usePageTitle(pageTitle);

  // const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [customers, setCustomers] = useState([]);

  const tableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    // { Header: "Last Name", accessor: "last_name", align: "left" },
    // { Header: "First Name", accessor: "first_name", align: "left" },
    { Header: "Email", accessor: "email_address", align: "left" },
    { Header: "Phone", accessor: "phone_number", align: "left" },
    { Header: "Purchases", accessor: "sales", align: "left" },
    { Header: "Volume", accessor: "volume", align: "left" },
    // { Header: "Mobile Network", accessor: "network", align: "left" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((customer) => {
      rows.push({
        name: `${customer.last_name} ${customer.first_name}`,
        // last_name: customer.last_name,
        // first_name: customer.first_name,
        email_address: customer.email_address,
        phone_number: customer.phone_number,
        // network: customer.mobile_network,
        sales: customer.sales.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }),
        volume: `${customer.currency}${(customer.volume / 100).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        created: customer.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/customers.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.customers);
            setCustomers(rows);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={1}>
                <MDBox
                  px={2}
                  pt={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" fontWeight="medium">
                    Customers
                  </MDTypography>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    iconOnly
                    onClick={() => {
                      const downloadUrl = `${AppConfig.api_base_url}account/customers/${accountInfo.account.reference}/${accountInfo.user.reference}/export.json`;
                      window.open(downloadUrl, "_blank");
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                  </MDButton>
                </MDBox>
                <MDBox mt={5}>
                  <DataTable
                    table={{ columns: tableColumns, rows: customers }}
                    isSorted
                    entriesPerPage
                    showTotalEntries
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Customers;
